import {
  Box,
  Typography,
  Grid,
  Card,
  CardContent,
  Divider,
  Stack,
  Link,
  Button,
} from "@mui/material";
import { useLocation } from "react-router-dom";
import PersonIcon from "@mui/icons-material/Person";
import PhoneIcon from "@mui/icons-material/Phone";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import MapIcon from "@mui/icons-material/Map";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import PaymentIcon from "@mui/icons-material/Payment";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import DescriptionIcon from "@mui/icons-material/Description";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import moment from "moment";
import colors from "../../styles/colors";
import { ErrorToaster, SuccessToaster } from "../../components/Toaster/Toaster";

export default function Detail() {
  const { state } = useLocation();
  const order = state || {};

  const handleCopy = () => {
    const text = `
📋 Order Details
-----------------------------
 Order Id: ${order.order_id || "N/A"}
 Customer Name: ${order.customer_name || "N/A"}
 Phone: ${order.customer_phone || "N/A"}
 Delivery Address: ${order.customer_address || "N/A"}
 Delivery Map Address: ${order.google_map_location || "N/A"}
 PickUp Address: ${order.pickup_address || "N/A"}
 PickUp Map Address: ${order.pickup_google_address || "N/A"}

 Order Status: ${order.status || "N/A"}
 Payment Mode: ${order.payment_mode || "N/A"}
 Payment Amount: ${order.payment_amount || "0.00"}
 Pharmacy Name: ${order?.pharmacy_id?.name || "N/A"}
 Order Details: ${order.order_details || "N/A"}
 Date: ${order.date ? moment(order.date).format("DD/MM/YYYY hh:mm a") : "N/A"}
 `;

    navigator.clipboard
      .writeText(text)
      .then(() => {
        SuccessToaster(" Order details copied to clipboard!");
      })
      .catch(() => {
        ErrorToaster(" Failed to copy order details.");
      });
  };

  return (
    <Box px={4} pb={2} maxWidth="lg" mx="auto">
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Typography
          variant="h4"
          component="h3"
          fontWeight="extrabold"
          color="primary.main"
          sx={{ mb: 2, textShadow: "2px 2px 4px rgba(0,0,0,0.1)" }}
        >
          Order Details
        </Typography>
        <Button
          onClick={handleCopy}
          sx={{
            background: colors.primary,
            color: "white",
            px: 3,
            py: 1,
            // height: "35px",
            ":hover": {
              background: colors.primary,
              opacity: 0.9,
            },
          }}
        >
          Copy Data
        </Button>
      </Box>
      <Card
        sx={{
          borderRadius: 4,
          boxShadow: 10,
          mt: 3,
          //   background: "linear-gradient(145deg, #f0f2f5, #e0e3e8)",
          p: 3,
        }}
      >
        <CardContent>
          <Grid container spacing={4}>
            <Grid item xs={12} md={6}>
              <Typography
                variant="h6"
                fontWeight="bold"
                gutterBottom
                color="text.primary"
                sx={{ mb: 2 }}
              >
                Customer Information
              </Typography>
              <Stack spacing={2}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Box
                    sx={{
                      bgcolor: "primary.light",
                      borderRadius: "50%",
                      p: 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <PersonIcon color="primary" sx={{ color: "white" }} />
                  </Box>
                  <Typography variant="body1" color="text.primary">
                    <b>Customer Name:</b> {order.customer_name}
                  </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Box
                    sx={{
                      bgcolor: "primary.light",
                      borderRadius: "50%",
                      p: 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <PhoneIcon color="primary" sx={{ color: "white" }} />
                  </Box>
                  <Typography variant="body1" color="text.primary">
                    <b>Phone:</b> {order.customer_phone}
                  </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Box
                    sx={{
                      bgcolor: "primary.light",
                      borderRadius: "50%",
                      p: 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <LocationOnIcon color="primary" sx={{ color: "white" }} />
                  </Box>
                  <Typography variant="body1" color="text.primary">
                    <b>Delivery Address:</b> {order.customer_address}
                  </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Box
                    sx={{
                      bgcolor: "primary.light",
                      borderRadius: "50%",
                      p: 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <MapIcon color="primary" sx={{ color: "white" }} />
                  </Box>
                  <Typography variant="body1" color="text.primary">
                    <b>Delivery Map Address:</b>{" "}
                      {order.latitude && order.longitude ? (
                      <Link
                        component="button"
                        variant="body2"
                        color="primary"
                        onClick={() => {
                          const latitude = order.latitude;
                          const longitude = order.longitude;
                          // Construct the Google Maps URL
                          const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;

                          // Open the URL in a new tab ('_blank')
                          window.open(mapsUrl, '_blank');
                        }}
                        sx={{ textDecoration: "underline", cursor: "pointer" }}
                      >
                        { order.google_map_location ? order.google_map_location : "N/A"}
                      </Link>
                     ) : (
                      <Link   component="button"
                      variant="body2"
                      color="primary"
                      onClick={() => {
                        if (order.customer_map_link) {
                          window.open(order.customer_map_link, "_blank");
                        }else if( order?.google_map_location){
                          window.open( order?.google_map_location, "_blank");

                        }
                      }}
                      sx={{ textDecoration: "underline", cursor: "pointer" ,wordBreak:"break-all" }}>
                      { order.customer_map_link ? order.customer_map_link : order?.google_map_location}
                      </Link>
                    )} 
                   
                  </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Box
                    sx={{
                      bgcolor: "primary.light",
                      borderRadius: "50%",
                      p: 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <LocationOnIcon color="primary" sx={{ color: "white" }} />
                  </Box>
                  <Typography variant="body1" color="text.primary">
                    <b>Pickup Address:</b> {order.pickup_address}
                  </Typography>

                </Stack>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Box
                    sx={{
                      bgcolor: "primary.light",
                      borderRadius: "50%",
                      p: 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <MapIcon color="primary" sx={{ color: "white" }} />
                  </Box>
                  <Typography variant="body1" color="text.primary">
                    <b>Pickup Map:</b>{" "}
                    {order.pickup_latitude && order.pickup_longitude ? (
                      <Link
                        component="button"
                        variant="body2"
                        color="primary"
                        onClick={() => {
                          const latitude = order.pickup_latitude;
                          const longitude = order.pickup_longitude;
                          // Construct the Google Maps URL
                          const mapsUrl = `https://www.google.com/maps/search/?api=1&query=${latitude},${longitude}`;

                          // Open the URL in a new tab ('_blank')
                          window.open(mapsUrl, '_blank');
                        }}
                        sx={{ textDecoration: "underline", cursor: "pointer" }}
                      >
                        { order.pickup_google_address ? order.pickup_google_address : "N/A"}
                      </Link>
                     ) : (
                      <Link   component="button"
                      variant="body2"
                      color="primary"
                      onClick={() => {
                        if (order.pickup_map_link) {
                          window.open(order.pickup_map_link, "_blank");
                        }else if(order?.pickup_google_address){
                          window.open(order?.pickup_google_address, "_blank");
                        }
                      }}
                      sx={{ textDecoration: "underline", cursor: "pointer" ,wordBreak:"break-all" }}>
                      {order.pickup_map_link ? order.pickup_map_link : order?.pickup_google_address}
                      </Link>
                    )} 

                  </Typography>
                </Stack>

                
              </Stack>
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography
                variant="h6"
                fontWeight="bold"
                gutterBottom
                color="text.primary"
                sx={{ mb: 2 }}
              >
                Order Summary
              </Typography>
              <Stack spacing={2}>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Box
                    sx={{
                      bgcolor: "primary.light",
                      borderRadius: "50%",
                      p: 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <ShoppingCartIcon color="primary" sx={{ color: "white" }} />
                  </Box>
                  <Typography variant="body1" color="text.primary">
                    <b>Order ID:</b> {order.order_id || "N/A"}
                  </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Box
                    sx={{
                      bgcolor: "primary.light",
                      borderRadius: "50%",
                      p: 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <ShoppingCartIcon color="primary" sx={{ color: "white" }} />
                  </Box>
                  <Typography variant="body1" color="text.primary">
                    <b>Order Status:</b> {order.status}
                  </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Box
                    sx={{
                      bgcolor: "primary.light",
                      borderRadius: "50%",
                      p: 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <PaymentIcon color="primary" sx={{ color: "white" }} />
                  </Box>
                  <Typography variant="body1" color="text.primary">
                    <b>Payment Mode:</b> {order.payment_mode}
                  </Typography>
                </Stack>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Box
                    sx={{
                      bgcolor: "primary.light",
                      borderRadius: "50%",
                      p: 1,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <AttachMoneyIcon color="primary" sx={{ color: "white" }} />
                  </Box>
                  <Typography variant="body1" color="text.primary">
                    <b>Payment Amount:</b>{" "}
                    {order.payment_amount ? order.payment_amount : "0.00"}
                  </Typography>
                </Stack>
              </Stack>
            </Grid>
            <Grid item xs={12}>
              <Divider
                sx={{
                  my: 4,
                  borderColor: "grey.400",
                  borderStyle: "dashed",
                  borderBottomWidth: 2,
                }}
              />
              <Typography
                variant="h6"
                fontWeight="bold"
                gutterBottom
                color="text.primary"
                sx={{ mb: 2 }}
              >
                Order Specifics
              </Typography>
              <Stack direction="row" alignItems="flex-start" spacing={2}>
                <Box
                  sx={{
                    bgcolor: "primary.light",
                    borderRadius: "50%",
                    p: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <DescriptionIcon color="primary" sx={{ color: "white" }} />
                </Box>
                <Typography variant="body1" color="text.primary">
                  <b>Order Details:</b> {order.order_details}
                </Typography>
              </Stack>
            </Grid>
            <Grid item xs={12}>
              <Divider
                sx={{
                  my: 4,
                  borderColor: "grey.400",
                  borderStyle: "dashed",
                  borderBottomWidth: 2,
                }}
              />
              <Typography
                variant="h6"
                fontWeight="bold"
                gutterBottom
                color="text.primary"
                sx={{ mb: 2 }}
              >
                Date & Time
              </Typography>
              <Stack direction="row" alignItems="center" spacing={2}>
                <Box
                  sx={{
                    bgcolor: "primary.light",
                    borderRadius: "50%",
                    p: 1,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <CalendarTodayIcon color="primary" sx={{ color: "white" }} />
                </Box>
                <Typography variant="body1" color="text.primary">
                  <b>Date:</b>{" "}
                  {order.date
                    ? moment(order?.date).format("DD/MM/YYYY hh:mm a")
                    : "N/A"}
                </Typography>
              </Stack>
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
}
